'use client'
import { useEffect } from "react";

export default function ImportBsJS() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const loadBootstrap = async () => {
      try {
        await import("bootstrap/dist/js/bootstrap.bundle.min.js");
      } catch (e) {
        console.error("Failed to load bootstrap bundle:", e);
      }
    };

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(() => {
        loadBootstrap();
      });
      return;
    }

    const t = setTimeout(() => loadBootstrap(), 1500);
    return () => clearTimeout(t);
  }, []);
  return null;
}
